import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

interface StepSummaryProps {
  summaryText: string;
  metadataBadges?: string[];
}

export const StepSummary = ({
  summaryText,
  metadataBadges = [],
}: StepSummaryProps) => {
  return (
    <Box sx={{ mt: 0.5, pl: { xs: 0, sm: 5 } }}>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          fontSize: '0.825rem',
          lineHeight: 1.4,
          wordBreak: 'break-word',
        }}
      >
        {summaryText}
      </Typography>

      {metadataBadges.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mt: 1 }}>
          {metadataBadges.map((badge, idx) => (
            <Chip
              key={idx}
              size="small"
              label={badge}
              variant="outlined"
              sx={{
                height: 22,
                fontSize: '0.7rem',
                borderRadius: '6px',
                borderColor: 'divider',
                bgcolor: 'grey.50',
                color: 'text.secondary',
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};
